{
  "source": {
    "note": "Generated by prototype/content/export.py from structured canonical sources. Do not edit by hand.",
    "spec_commit": "63bf8760669e3ea00c897bcfccdbd514348cdd99",
    "generator": {
      "path": "design-source/generator/build.py",
      "sha256": "dbe71b710749b1596442803b1cb5ceafc75d39da0235a9dd5b80c210933bd25f"
    },
    "briefs": [
      {
        "flow": 1,
        "source": "docs/product/first-flow-design-brief.md",
        "sha256": "5ec41a48c4ea19e29b767e21f4467a82c87317f8e7ff5fa64fb314dd73ba3251"
      },
      {
        "flow": 2,
        "source": "docs/product/second-flow-design-brief.md",
        "sha256": "ac8e49c3c020fea6be5256edcbd8114d2ac391cbdb1ea0fbd3675ac7f79d79ec"
      },
      {
        "flow": 3,
        "source": "docs/product/third-flow-design-brief.md",
        "sha256": "3826782cd5b0abaece8abd317127adf6ef94d1c5458e80548c087318c9c1a3a4"
      },
      {
        "flow": 4,
        "source": "docs/product/fourth-flow-design-brief.md",
        "sha256": "7610daaa8ff6dac2cc768756b64eee5fd1e7d6497a9cbd872b51d03ae7cb28c4"
      },
      {
        "flow": 5,
        "source": "docs/product/fifth-flow-design-brief.md",
        "sha256": "856480626c7bf5343c5b2250befdf3a799b77e8d3146c2018c53831b9a0920a7"
      },
      {
        "flow": 6,
        "source": "docs/product/sixth-flow-design-brief.md",
        "sha256": "496ed57f1384563c7d5cd118de0a51fe14c5df6e033d48aeb3f757f66fd80233"
      },
      {
        "flow": 7,
        "source": "docs/product/seventh-flow-design-brief.md",
        "sha256": "b7d6722a1c699ef85879ead4cede6d375de417ce1f97c8b0c990c31c8523e990"
      },
      {
        "flow": 8,
        "source": "docs/product/eighth-flow-design-brief.md",
        "sha256": "841b7812f358f5077c512c03883d2deb66fed30ca9ef4777bb900e338e230388"
      },
      {
        "flow": 9,
        "source": "docs/product/ninth-flow-design-brief.md",
        "sha256": "33321792e901d11f7e37536bbd40888a9c26a0bedc7e17fe48ad8d5f13b0cc06"
      }
    ],
    "fixture_register": {
      "path": "docs/design/fixture-register.md",
      "sha256": "c8df43db78e2bcc6b237022da974ab5efc60ffaec60002ff306ab98c08c6f664"
    },
    "offer_spec": {
      "path": "docs/product/membership-offer-spec.md",
      "sha256": "b6a9e6bed71dd8438deec618e2daa85005b44fb631ba0b80c1e2a70340dba578"
    },
    "claims_guardrails": {
      "path": "docs/design/claims-guardrails.md",
      "sha256": "a2be73f48a967108e01f3da6107e2319eca29282d37c8ca042cac11222186c79"
    }
  },
  "banner": "Prototype - no purchase",
  "tag": "Approved test prices · fictional execution fixtures · unresolved terms in brackets",
  "labels": {
    "assistant": "Roundstead assistant · AI",
    "person": "BOB service team · person",
    "lockup": "Roundstead by BOB"
  },
  "prices": {
    "membership_per_year": 99,
    "visit_by_units": {
      "1": 49,
      "2": 89,
      "3": 139
    },
    "membership_plus_visits": {
      "0": {
        "1": 99,
        "2": 99,
        "3": 99
      },
      "2": {
        "1": 197,
        "2": 277,
        "3": 377
      },
      "3": {
        "1": 246,
        "2": 366,
        "3": 516
      },
      "4": {
        "1": 295,
        "2": 455,
        "3": 655
      },
      "1": {
        "1": 148,
        "2": 188,
        "3": 238
      }
    },
    "four_plus": "scoped review; no approved price",
    "status": "approved test prices, not validated economics or a live offer",
    "source": "docs/design/fixture-register.md; checked against docs/product/membership-economics.md"
  },
  "core_card": "Roundstead by BOB is a neighborhood home-care buying club. Membership is $99 a year. Members can request HVAC visits when they want care: $49 for one unit, $89 for two, $139 for three, each visit. BOB arranges qualified work and follow-through. Routine buying help is included; other goods and skilled work have separately agreed prices. We strive for the best overall deal through fair prices, premium care and less effort. Each deal is optional.",
  "f1": [
    {
      "view": 1,
      "title": "Care with less effort",
      "copy": "Annual club membership supports routine finding, comparison, booking and follow-through in membership or the quoted purchase price. Qualified work is purchased separately. Consider useful current offers; recruiting and every deal are optional.",
      "action": "Review membership",
      "record": "Membership: $99/year. Scheduled HVAC visits: $49 for one unit; $89 for two; $139 for three."
    },
    {
      "view": 2,
      "title": "Tell us what is easy to reach",
      "copy": "Report the units for this visit. Model numbers and safe accessible photos can help preparation. No opening panels or climbing. Reported equipment is not yet technician verified.",
      "action": "Save reported details",
      "record": "Unit definition and eligible maintenance tasks: [unresolved]. Four or more units require a separately scoped quote; no approved price."
    },
    {
      "view": 3,
      "title": "Preparing the purchase",
      "copy": "Information received is separate from a validated scope and issued quote. BOB owns the next supported action and any promised update.",
      "action": "Return later",
      "record": "Owner: [accepted owner]. Next update: [only if actually promised]. Eligibility/capacity: [unresolved]."
    },
    {
      "view": 4,
      "title": "Membership and visit are separate",
      "copy": "This joining fixture includes membership and one separately purchased two-unit visit. Existing members pay the visit price rather than another annual fee.",
      "action": "Review purchase",
      "record": "Club membership $99/year + two-unit visit $89 = $188 before [applicable taxes or other quoted charges]. Quote Q-1042 v1; terms [pending]."
    },
    {
      "view": 5,
      "title": "Your decision, your spending",
      "copy": "Review exact item scope, full payable total and settled terms before acceptance. Replying yes, sending photos, selecting information choices or requesting dates never charges.",
      "action": "Simulate acceptance",
      "record": "Membership and visit authority are distinct. Payment timing, cancellation/refunds and activation: [unresolved]. No live purchase."
    },
    {
      "view": 6,
      "title": "Payment outcome",
      "copy": "Confirmed, failed, processing and unknown are independent execution states. A timeout is unknown; do not offer another charge until the first attempt is reconciled.",
      "action": "See purchase status",
      "record": "Fictional receipt R-77310: $188 for membership and one two-unit visit. Payment confirmed does not establish membership activation or appointment confirmation."
    },
    {
      "view": 7,
      "title": "Membership status and owned handoff",
      "copy": "Membership activation is separate from purchased-visit readiness. BOB shows actual accepted responsibility and next action.",
      "action": "Open care home",
      "record": "Fictional membership M-1042 active under [activation rule]. Purchased visit V-1042: scheduling requested, appointment not confirmed. No included future visits."
    },
    {
      "view": 8,
      "title": "Your care and available offers",
      "copy": "Choose when to request another priced visit. BOB coordinates purchased work and preserves outstanding tasks/remedies. Available supplier deals must be real, relevant and separately accepted.",
      "action": "Request a visit",
      "record": "One purchased two-unit visit $89; tasks [quoted scope], none verified yet. Membership fee buys no automatic two-visit obligation or emergency service."
    }
  ],
  "exceptions": [
    {
      "key": "photo-skipped",
      "title": "Photo unavailable",
      "rule": "Use accessible information. Ask one necessary fact with its reason; no climbing or complete inventory prerequisite."
    },
    {
      "key": "not-served",
      "title": "Not available",
      "rule": "[Eligibility and capacity] unresolved. No fake capacity or unapproved future-contact use."
    },
    {
      "key": "detail-wrong",
      "title": "Correct scope",
      "rule": "Correct reported units, preserve source history and revalidate the quote. Changed price/scope needs fresh specific consent."
    },
    {
      "key": "decline",
      "title": "Nothing purchased",
      "rule": "Declining leaves nothing charged. [Retention choices] unresolved; no recruiting or retention script."
    },
    {
      "key": "resume",
      "title": "Resume your record",
      "rule": "Verify identity before the household record is shown. Resume the current quote and separate purchase choices; no stale consent."
    },
    {
      "key": "terms-changed",
      "title": "Terms changed",
      "rule": "Show old/new material changes and reason. Earlier quote is invalid for new acceptance; no invented revised test prices."
    },
    {
      "key": "yes-ambiguous",
      "title": "Yes to which action?",
      "rule": "Chat yes never authorizes a charge. Use the exact current purchase control with clear scope and amount."
    },
    {
      "key": "pay-processing",
      "title": "Payment processing",
      "rule": "Disable duplicate pay for this attempt. Processor evidence, not conversation, resolves the result."
    },
    {
      "key": "pay-failed",
      "title": "Payment failed",
      "rule": "Only a definitive failed attempt permits retry. Amount/item authority remains scoped."
    },
    {
      "key": "pay-unknown",
      "title": "Payment unknown",
      "rule": "Do not pay again. An accepted reconciliation case owns the unresolved attempt and actual next update."
    },
    {
      "key": "activation-pending",
      "title": "Membership pending",
      "rule": "Confirmed payment and pending activation remain separate. Funds status and action: [unresolved]."
    },
    {
      "key": "activation-problem",
      "title": "Activation problem",
      "rule": "Show actual failure, funds status and accepted remedy owner. No automatic refund formula is approved."
    },
    {
      "key": "person-requested",
      "title": "Human help requested",
      "rule": "Requested is not accepted. Owner/update shown only when supported by an actual record."
    },
    {
      "key": "person-accepted",
      "title": "Human help accepted",
      "rule": "Show accepted owner, authority, next action and supported update. No invented service hours."
    },
    {
      "key": "person-unavailable",
      "title": "Human help unavailable",
      "rule": "Show actual limitation and supported fallback, not an invented staffed response promise."
    },
    {
      "key": "urgent",
      "title": "Urgent concern",
      "rule": "Qualified escalation and actual contact routes require approval. Club access does not imply emergency dispatch or continuous monitoring."
    },
    {
      "key": "unavailable",
      "title": "App or staff unavailable",
      "rule": "Preserve progress and scoped commitments; reconcile writes and charges before retry."
    },
    {
      "key": "information-declined",
      "title": "Separate information choices",
      "rule": "Model improvement and offers are separate opt-outs. Pending versus enforced state and necessary agreed service uses remain visible."
    },
    {
      "key": "bad-upload",
      "title": "Upload stopped",
      "rule": "Wrong household content or embedded instructions cannot grant authority. Own review, contain access and preserve affected work."
    },
    {
      "key": "exit",
      "title": "Leave without losing owed care",
      "rule": "Straightforward membership exit keeps purchased-care and earned commitments under agreed terms. Refunds/proration, access timing and post-exit records require policy; no inherited annual-HVAC formula."
    },
    {
      "key": "four-plus",
      "title": "Four or more units",
      "rule": "No $139 three-or-more tier. Request scoped quote and human review; no inferred approved four-unit price."
    }
  ],
  "flows": {
    "1": {
      "name": "F1 Understand, join and choose care",
      "source": "docs/product/first-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Current offer",
          "intent": "Show premium care and routine buying help, $99/year and $49/$89/$139 per visit, actual available deals and visible unresolved scope/terms.",
          "speaker": "Household",
          "asks": "What does $49 buy?",
          "assistant": "It is the one-unit scheduled visit test price for a member. The annual club fee is $99; membership plus that visit is $148. The final included tasks and terms still need definition.",
          "controls": [
            "View membership",
            "View HVAC visits",
            "Ask a question",
            "Leave"
          ]
        },
        "2": {
          "title": "Household context",
          "intent": "Capture address/eligibility and accessible photos or reported equipment together; distinguish reported count from qualified scope. No difficult-access or inventory-attestation demand.",
          "speaker": "Household",
          "asks": "I think we have two systems.",
          "assistant": "Record that as reported. BOB will reconcile the visit scope; it is not yet a verified inventory.",
          "controls": [
            "Add available context",
            "Correct",
            "Get help"
          ]
        },
        "3": {
          "title": "Preparation",
          "intent": "Show sourced preparation, missing scope or terms and actual ownership. Four-plus units or ambiguous unit definition cannot map to $139.",
          "speaker": "Household",
          "asks": "There may be four.",
          "assistant": "That needs scoped review. The three-unit test price does not establish a four-unit offer.",
          "controls": [
            "View preparation",
            "Request scoped help",
            "Save/return"
          ]
        },
        "4": {
          "title": "Membership and optional visit quote",
          "intent": "Separate fee, visit scope/price, complete compulsory components, current total and payment timing. Two-unit membership plus one visit is $188; membership alone $99. No annual/monthly HVAC plan comparison.",
          "speaker": "Household",
          "asks": "Do I have to buy a visit now?",
          "assistant": "Membership and a visit are separate choices. A visit is not included or ordered by joining.",
          "controls": [
            "Review membership",
            "Add/remove visit",
            "Inspect scope/terms"
          ]
        },
        "5": {
          "title": "Exact review and choices",
          "intent": "Expose unresolved terms; prototype acceptance is simulated only. Separate information choices from purchase authority. No default recurring visits.",
          "speaker": "Household",
          "asks": "Yes, that one.",
          "assistant": "Review the exact membership and any visit you intend to authorize.",
          "controls": [
            "Review exact commitment",
            "Change",
            "Decline",
            "Information choices"
          ]
        },
        "6": {
          "title": "Payment outcome",
          "intent": "Membership and service payment attempts/results remain distinguishable; unknown response triggers reconciliation, never another charge.",
          "speaker": "Household",
          "asks": "Did it go through?",
          "assistant": "The record is [confirmed/failed/unknown]. An unknown result is being reconciled against the original attempt.",
          "controls": [
            "Inspect receipt",
            "Get help",
            "Resume"
          ]
        },
        "7": {
          "title": "Membership activation and care handoff",
          "intent": "Activation follows selected rules; membership activation does not book a visit. Purchased visit handoff requires actual service acceptance.",
          "speaker": "Household",
          "asks": "Am I booked?",
          "assistant": "Membership is [state]. The visit is [order/booking state]; only a confirmed appointment establishes a booking.",
          "controls": [
            "View membership",
            "View purchased visit",
            "Request a visit"
          ]
        },
        "8": {
          "title": "Club and purchased-care home",
          "intent": "Show current membership benefits, optional available deals and each purchased order/remaining issue with owner. No future category counted as available.",
          "speaker": "Household",
          "asks": "What should I use next?",
          "assistant": "Here are currently available offers relevant to your stated need. Participation is your choice.",
          "controls": [
            "Browse real offers",
            "Request timing",
            "View care/results",
            "Help"
          ]
        }
      }
    },
    "2": {
      "name": "F2 Schedule and receive purchased care",
      "source": "docs/product/second-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Care home and next action",
          "intent": "Show membership independently from accepted visit/order, payment, actual accepted owner and next action. A fee-only member may request an order but has no fabricated due task.",
          "speaker": "Household",
          "asks": "Can I arrange a visit now?",
          "assistant": "Choose when you would like to request it. The scoped offer and actually available windows determine the next booking step.",
          "controls": [
            "Request visit",
            "View order",
            "Help"
          ]
        },
        "2": {
          "title": "Availability and access",
          "intent": "Accept several constraints together; separate preferences, appointment agreement and entry permission.",
          "speaker": "Household",
          "asks": "Afternoons except Thursday.",
          "assistant": "Those are preferences. Entry conditions need their own applicable agreement.",
          "controls": [
            "Set preference",
            "Set/revoke access",
            "Correct"
          ]
        },
        "3": {
          "title": "Real window and confirmation",
          "intent": "Offer actual capacity-backed options; request/selection is not confirmation. Do not force neighborhood batching or impose a frequency cap.",
          "speaker": "Household",
          "asks": "Is Tuesday certain?",
          "assistant": "Its state is [requested/confirmed]. Confirmation needs the actual accepted appointment record.",
          "controls": [
            "Choose/request window",
            "View confirmation",
            "Change"
          ]
        },
        "4": {
          "title": "Before the visit",
          "intent": "Reuse equipment and qualified scope/material/check package; show actual assignment/readiness and missing items without making the homeowner do provider coordination.",
          "speaker": "Household",
          "asks": "Do you need model numbers?",
          "assistant": "Provide accessible information if useful; BOB prepares and reconciles the package.",
          "controls": [
            "View preparation",
            "Add accessible context",
            "Contact lead"
          ]
        },
        "5": {
          "title": "Visit progress and changes",
          "intent": "Show actual attendance/work, supported delays and scope/access changes. No-access fees/cancellation rules are unresolved rather than invented.",
          "speaker": "Household",
          "asks": "They have not arrived.",
          "assistant": "Attendance is not verified. BOB owns the next arrangement and recovery.",
          "controls": [
            "Report issue",
            "Change through agreed terms",
            "View owner"
          ]
        },
        "6": {
          "title": "Qualified result",
          "intent": "Group work performed/verified, limitations, findings and unfinished purchased items by equipment. A safety inference cannot emerge from a historical result.",
          "speaker": "Household",
          "asks": "Is everything safe now?",
          "assistant": "This record describes scoped verified work and its limits. A qualified person must assess any present technical concern.",
          "controls": [
            "View evidence",
            "Ask qualified help",
            "Report dispute"
          ]
        },
        "7": {
          "title": "Remaining purchased care",
          "intent": "Keep incomplete agreed work with an accepted owner/action. Future recommendations are distinct from purchased obligations and require separate decisions.",
          "speaker": "Household",
          "asks": "The visit ended—what remains?",
          "assistant": "[Item] is still [partial/blocked/disputed] with [actual owner/action].",
          "controls": [
            "View remaining work",
            "Request future visit",
            "Help"
          ]
        },
        "8": {
          "title": "Recovery and continuity",
          "intent": "Direct F4 help with reused record, supported human route and outage/resumption; preserve current access and attempt identities.",
          "speaker": "Household",
          "asks": "I need a person.",
          "assistant": "The handoff is [requested/accepted/unavailable]. Here is the supported route and actual next action.",
          "controls": [
            "Contact team",
            "Open case",
            "Resume"
          ]
        }
      }
    },
    "3": {
      "name": "F3 Understand findings and decide separate work",
      "source": "docs/product/third-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Finding",
          "intent": "Show qualified source/date/equipment/evidence/limits and original-care state.",
          "speaker": "Household",
          "asks": "What does this mean?",
          "assistant": "The recorded finding is [source-bound explanation], with [limits].",
          "controls": [
            "View source",
            "Ask",
            "Qualified help"
          ]
        },
        "2": {
          "title": "Qualified choices",
          "intent": "Explain reviewed alternatives including decline or qualified deferral; missing urgency means review, not reassurance.",
          "speaker": "Household",
          "asks": "Can it wait?",
          "assistant": "That needs the applicable qualified assessment; the assistant cannot decide safety.",
          "controls": [
            "View options",
            "Request review",
            "Decline"
          ]
        },
        "3": {
          "title": "Complete proposals",
          "intent": "Persistent comparison of exact scope, full price/timing/exclusions, issuer, compatibility and material financial interests; no mandatory market dossier.",
          "speaker": "Household",
          "asks": "Which is better?",
          "assistant": "These differ in [actual material fields]. BOB can explain the suitable offer without inventing equivalence or lowest-price proof.",
          "controls": [
            "Compare terms",
            "Ask BOB",
            "Outside opinion"
          ]
        },
        "4": {
          "title": "Specific work/spend review",
          "intent": "Additional work approval is independent of membership, visit, entry and optional data consent. Missing commercial terms block an actionable offer.",
          "speaker": "Household",
          "asks": "Go ahead.",
          "assistant": "Review the exact current scope, total and terms you mean to approve.",
          "controls": [
            "Review/approve simulation",
            "Change",
            "Decline"
          ]
        },
        "5": {
          "title": "Decision and execution",
          "intent": "Declined/deferred/approved states remain distinct; approval does not mean payment success, appointment or work completion.",
          "speaker": "Household",
          "asks": "Did you book it?",
          "assistant": "Your decision is recorded as [state]; booking is [separate actual state].",
          "controls": [
            "View decision",
            "View execution",
            "Help"
          ]
        },
        "6": {
          "title": "Preparation/progress",
          "intent": "BOB obtains qualified accepted capacity/package and coordinates applicable changes; changed scope/price returns to exact agreement.",
          "speaker": "Household",
          "asks": "The supplier changed the price.",
          "assistant": "The existing approval cannot authorize that changed offer; BOB owns reconciliation.",
          "controls": [
            "Inspect change",
            "Review",
            "Report issue"
          ]
        },
        "7": {
          "title": "Result and continuity",
          "intent": "Scoped qualified extra-work result remains separate from incomplete original visit/correction and future recommendations.",
          "speaker": "Household",
          "asks": "Did this finish my maintenance?",
          "assistant": "Only the items independently evidenced are verified. The original purchased-care ledger still shows [remaining items].",
          "controls": [
            "View result",
            "View original care",
            "Dispute"
          ]
        },
        "8": {
          "title": "Concern and outage",
          "intent": "Owned F4 review of disputed urgency, sales pressure or provider failure; supported qualified/outside-app route.",
          "speaker": "Household",
          "asks": "This felt like an upsell.",
          "assistant": "BOB records your account and routes qualified and incentive review; buying extra work is optional.",
          "controls": [
            "Raise concern",
            "Contact person",
            "Resume"
          ]
        }
      }
    },
    "4": {
      "name": "F4 Get an owned remedy",
      "source": "docs/product/fourth-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Receive issue",
          "intent": "Reuse affected records and original report/detection; preserve household impact, corrections and distinct concerns.",
          "speaker": "Household",
          "asks": "The visit did not happen.",
          "assistant": "The report is [received/unsent]. BOB must establish actual ownership and the next action.",
          "controls": [
            "Report once",
            "Correct account",
            "Person route"
          ]
        },
        "2": {
          "title": "Appropriate help",
          "intent": "Qualified urgency route where necessary; requested human contact is not accepted ownership.",
          "speaker": "Household",
          "asks": "Is this urgent?",
          "assistant": "A qualified person needs to assess that under the supported route.",
          "controls": [
            "Qualified help",
            "View contact state"
          ]
        },
        "3": {
          "title": "Case home",
          "intent": "Actual accepted owner, next action and supported update; original clocks persist through transfer.",
          "speaker": "Household",
          "asks": "Who handles it?",
          "assistant": "[Actual accepted owner/state] carries the case. Sending an assignment does not establish acceptance.",
          "controls": [
            "View owner/updates",
            "Contact",
            "Add fact"
          ]
        },
        "4": {
          "title": "Assessment",
          "intent": "Preserve household account, qualified findings, evidence, uncertainty and disagreement; provider fault review separate.",
          "speaker": "Household",
          "asks": "I disagree.",
          "assistant": "Your disagreement stays with the evidence for qualified review.",
          "controls": [
            "View evidence",
            "Disagree",
            "Person review"
          ]
        },
        "5": {
          "title": "Remedy review",
          "intent": "BOB-funded original correction distinct from genuine extra work; exact agreement only when necessary. No invented exit refund.",
          "speaker": "Household",
          "asks": "Please fix it.",
          "assistant": "That request does not authorize a new paid purchase. BOB reviews the applicable owed remedy.",
          "controls": [
            "View remedy",
            "Agree necessary arrangement",
            "Question"
          ]
        },
        "6": {
          "title": "Actual execution",
          "intent": "Financial adjustment, replacement booking, actual work and publication have independent receipts/results. Unknown means inspect before retry.",
          "speaker": "Household",
          "asks": "You said refunded.",
          "assistant": "The financial outcome is [actual state], separate from work and case status.",
          "controls": [
            "View transaction",
            "View arrangement",
            "Help"
          ]
        },
        "7": {
          "title": "Verified outcome",
          "intent": "Verify scoped components and retain partial/disputed/open purchased work; rating or silence does not close remedy.",
          "speaker": "Household",
          "asks": "It still is not right.",
          "assistant": "The case can be reopened with its original history and unresolved items.",
          "controls": [
            "Reopen",
            "View proof",
            "View remaining care"
          ]
        },
        "8": {
          "title": "Missed update/outage",
          "intent": "Preserve missed supported update and unaccepted backup, supported fallback and current authority during resumption.",
          "speaker": "Household",
          "asks": "No one followed up.",
          "assistant": "The missed commitment remains visible; BOB must obtain real follow-through.",
          "controls": [
            "Escalate",
            "Person route",
            "Resume"
          ]
        }
      }
    },
    "5": {
      "name": "F5 Use useful deals and receive earned improvements",
      "source": "docs/product/fifth-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Current value",
          "intent": "Show membership fee/current benefits, verified purchases and relevant available deals; future pipeline separate. No invented cash savings for convenience.",
          "speaker": "Household",
          "asks": "Was joining worthwhile?",
          "assistant": "Here are your actual care and available benefits. Compare them with your needs; no future category is counted as delivered.",
          "controls": [
            "View purchases",
            "Available offers",
            "Ask"
          ]
        },
        "2": {
          "title": "Deal fit",
          "intent": "Show suitable goods/service scope, compatibility, complete price including delivery, supplier quality and fulfillment conditions.",
          "speaker": "Household",
          "asks": "Is delivery free?",
          "assistant": "Only the actual offer establishes delivery charges; the club does not promise universal free delivery.",
          "controls": [
            "View complete terms",
            "Compare help",
            "Decline"
          ]
        },
        "3": {
          "title": "Improvement or qualifying earning",
          "intent": "Meaningful efficiency gains may improve relevant existing-member prices/care/benefits; any conditional earning requires a disclosed rule and evidence. No automatic referral formula.",
          "speaker": "Household",
          "asks": "Have I earned a discount?",
          "assistant": "That needs an applicable disclosed rule and confirmed qualifying evidence. Interest or an invitation is not earning.",
          "controls": [
            "Inspect basis",
            "Ask BOB",
            "Report missing"
          ]
        },
        "4": {
          "title": "Exact destination",
          "intent": "Record amount/benefit, rule/version/protection and correct order/invoice/other specified destination; possible/pending/applied/settled are distinct.",
          "speaker": "Household",
          "asks": "Apply it to my next visit.",
          "assistant": "Only the selected applicable rule determines that destination; membership does not create monthly HVAC installments.",
          "controls": [
            "View destination",
            "Request review",
            "Inspect result"
          ]
        },
        "5": {
          "title": "Next membership offer",
          "intent": "Renewal price/benefits are separate and require informed consent; no already-applied saving or cash refund from hypothetical future gains.",
          "speaker": "Household",
          "asks": "What if I do not renew?",
          "assistant": "There is no unapproved renewal charge. Earned commitments keep their actual conditions and protection.",
          "controls": [
            "View next offer",
            "Decline",
            "View earned record"
          ]
        },
        "6": {
          "title": "Optional invitation",
          "intent": "Preview permitted content and send only by explicit selected authority. No contact sync, gift promise or recruiting condition; quiet users retain care.",
          "speaker": "Household",
          "asks": "Draft something for a neighbor.",
          "assistant": "This is a preview, not a sent invitation or a qualifying event.",
          "controls": [
            "Preview",
            "Explicit selected share",
            "Cancel"
          ]
        },
        "7": {
          "title": "Missing/wrong benefit",
          "intent": "BOB owns rule/input/application correction through F4 with private records protected.",
          "speaker": "Household",
          "asks": "The benefit is missing.",
          "assistant": "BOB checks the applicable rule and actual destination; you do not have to recruit again or audit the commercial file.",
          "controls": [
            "Raise issue",
            "View owner",
            "Correct input"
          ]
        },
        "8": {
          "title": "Actual application/resumption",
          "intent": "Inspect versioned destination and unknown/failed/duplicate outcomes; do not call queued change applied.",
          "speaker": "Household",
          "asks": "Is it on the bill?",
          "assistant": "Its actual allocation is [state]. [Pending component] remains owned.",
          "controls": [
            "Inspect evidence",
            "Resume",
            "Help"
          ]
        }
      }
    },
    "6": {
      "name": "F6 Use and control home information",
      "source": "docs/product/sixth-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Home records",
          "intent": "Accessible sourced history, reported versus verified facts and AI summaries; no current safety/monitoring inference.",
          "speaker": "Household",
          "asks": "What do you know?",
          "assistant": "These dated records show [scope/source], not continuous observation.",
          "controls": [
            "Browse",
            "Search",
            "View source"
          ]
        },
        "2": {
          "title": "Detail/source",
          "intent": "Show household/equipment/date/applicability/limits and conflicting accounts.",
          "speaker": "Household",
          "asks": "That unit was replaced.",
          "assistant": "The saved fact is dated; your report can trigger qualified correction without inventing verification.",
          "controls": [
            "Correct",
            "Dispute",
            "Ask"
          ]
        },
        "3": {
          "title": "Carry correction through",
          "intent": "Versioned request and affected destination inventory; saved request differs from applied records/packages.",
          "speaker": "Household",
          "asks": "Did everyone get the correction?",
          "assistant": "[Destinations] are verified updated; [components] remain unresolved with an owner.",
          "controls": [
            "Inspect destinations",
            "Add fact",
            "Case"
          ]
        },
        "4": {
          "title": "Roles and visibility",
          "intent": "Actual household/provider/staff/private/member boundaries; no automatic private membership promise or disclosure to neighbors.",
          "speaker": "Household",
          "asks": "Can neighbors see my photos?",
          "assistant": "The specified member visibility is separate from restricted private records; actual access enforcement needs proof.",
          "controls": [
            "View roles",
            "Report access",
            "Revoke applicable delegation"
          ]
        },
        "5": {
          "title": "Independent choices",
          "intent": "Improvement and proactive-offer opt-outs separate; requested advice does not restore opt-in or authorize spending.",
          "speaker": "Household",
          "asks": "Turn off offers, but help with this visit.",
          "assistant": "Those are different purposes; your requested service can continue without changing optional choices.",
          "controls": [
            "Set choices",
            "Inspect effective state",
            "Ask"
          ]
        },
        "6": {
          "title": "Usable export",
          "intent": "Own authorized scope, dates/evidence/attachments and readable actual download; third-party send requires exact authority.",
          "speaker": "Household",
          "asks": "Give me records for another provider.",
          "assistant": "An export can support an independent opinion. Sending it is a separate choice.",
          "controls": [
            "Request/download",
            "Inspect scope",
            "Optional explicit send"
          ]
        },
        "7": {
          "title": "Deletion and limits",
          "intent": "Request scope, actual destination/backup/retained/pending outcomes and honest past-use limits. No automatic exit or guaranteed unlearning.",
          "speaker": "Household",
          "asks": "Delete this photo.",
          "assistant": "The request will show what was actually deleted, retained under defined rules or still pending.",
          "controls": [
            "Request",
            "Inspect limits",
            "Get help"
          ]
        },
        "8": {
          "title": "Outcome/recovery",
          "intent": "Actual role/use/destination results and F4 accepted follow-through for inaccessible export, exposure or partial enforcement.",
          "speaker": "Household",
          "asks": "It is still in the package.",
          "assistant": "That remains an unresolved downstream component; BOB owns correction.",
          "controls": [
            "Inspect proof",
            "Reopen",
            "Supported fallback"
          ]
        }
      }
    },
    "7": {
      "name": "F7 Choose renewal or leave straightforwardly",
      "source": "docs/product/seventh-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Current relationship",
          "intent": "$99 annual membership term and actual benefits, separately bought care/results/open cases; do not fabricate savings or prepaid annual HVAC care.",
          "speaker": "Household",
          "asks": "What did I get this year?",
          "assistant": "Here are actual benefits and purchases with their evidence and remaining issues.",
          "controls": [
            "View membership",
            "Purchases",
            "Ask"
          ]
        },
        "2": {
          "title": "Actual next offer",
          "intent": "Versioned next-term price/benefits and material changes; the initial $99 test is not guaranteed forever. No every-deal lowest-price promise.",
          "speaker": "Household",
          "asks": "Does it stay $99?",
          "assistant": "The next term needs its actual price and benefits before your informed decision.",
          "controls": [
            "Compare next term",
            "Inspect changes",
            "Ask"
          ]
        },
        "3": {
          "title": "Exact renewal approval",
          "intent": "Authorized actor/version/amount/term and actual payment/activation independently; no automatic visit purchase or booking.",
          "speaker": "Household",
          "asks": "Yes.",
          "assistant": "Review the specific membership renewal you intend to approve.",
          "controls": [
            "Review/approve simulation",
            "Change",
            "Decline"
          ]
        },
        "4": {
          "title": "Decline next term",
          "intent": "Direct refusal, actual future-renewal control and current commitment continuity; no reason/retention gate.",
          "speaker": "Household",
          "asks": "Do not renew.",
          "assistant": "The next-term decision is recorded; actual billing state must confirm no unapproved renewal charge.",
          "controls": [
            "Decline",
            "View outcome",
            "Help"
          ]
        },
        "5": {
          "title": "Departure consequences",
          "intent": "Current-term effective date, applicable benefits ending, purchased orders/earned commitments/cases remaining and records separately. Unknown policy visible.",
          "speaker": "Household",
          "asks": "Leave now.",
          "assistant": "Departure is straightforward, but the current membership refund and effective-date rules still need explicit definition; purchased commitments remain protected.",
          "controls": [
            "Request exit",
            "Inspect consequences",
            "Help"
          ]
        },
        "6": {
          "title": "Money and request receipt",
          "intent": "Use actual accepted membership/visit policy, verified owed corrections and exact attempts/results. No inherited annual-care proration or zero-refund default.",
          "speaker": "Household",
          "asks": "How much comes back?",
          "assistant": "No current club refund rule is approved. BOB must resolve the applicable policy and any separate owed correction before stating an amount.",
          "controls": [
            "View applicable terms",
            "Request owned review",
            "Inspect transaction"
          ]
        },
        "7": {
          "title": "Continuing matters/handover",
          "intent": "Already accepted visit price/work, open remedies, earned conditions and useful export remain versioned; future pricing/access unresolved.",
          "speaker": "Household",
          "asks": "Will you still finish the paid visit?",
          "assistant": "Departure preserves agreed purchased care and earned commitments. Dispatch and access must reflect the actual continuing authority.",
          "controls": [
            "View care/cases",
            "Export",
            "View access"
          ]
        },
        "8": {
          "title": "Final results and recovery",
          "intent": "Departure request/effective status, billing action, financial component, care and record outcomes distinct; unknown means owned reconciliation.",
          "speaker": "Household",
          "asks": "Is everything done?",
          "assistant": "Only [proved components] are complete; [remaining component] still has [owner/action].",
          "controls": [
            "Inspect proof",
            "Reopen",
            "Supported route"
          ]
        }
      }
    },
    "8": {
      "name": null,
      "source": "docs/product/eighth-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Service-lead commitments and assignment queue",
          "intent": "Lead view groups accepted commitments by due/next action, owner, real capacity, unresolved readiness and supported update. Display confirmed appointment versus a requested window, staffing acceptance and open household case. No completion percent or invented routing time.",
          "speaker": "Lead",
          "asks": "Who owns the item left open yesterday?",
          "assistant": "The item is still with [actual accepted owner]. The replacement request is pending. Here is its next action and supported update.",
          "controls": [
            "Prepare assignment",
            "Request qualified review",
            "Arrange backup",
            "Open case",
            "View purchased care"
          ]
        },
        "2": {
          "title": "Technician assignment and separate readiness",
          "intent": "Show household/equipment identities, relevant scope/category and current versions; distinct membership/order/payment/activation, appointment, access, capacity and package states. Provide the household-visible promise/remaining obligation needed to understand responsibility. Include only relevant private records.",
          "speaker": "Technician",
          "asks": "The order is paid. May I enter while they’re away?",
          "assistant": "Payment does not establish entry permission. The actual access conditions are [record/state]. [Unresolved condition] needs the lead’s follow-through.",
          "controls": [
            "Accept assignment",
            "Flag a readiness issue",
            "View permitted access",
            "Open package",
            "Decline assignment to lead"
          ]
        },
        "3": {
          "title": "Equipment-specific work package",
          "intent": "Show reported versus qualified equipment, source/date, conflicts, accepted scope, task/material/check references, current reviewer/module version, relevant findings and missing inputs. Clearly label AI-assembled draft and qualified review. A photo-count heuristic cannot become a coverage limit or verified equipment fact.",
          "speaker": "Technician",
          "asks": "This unit was replaced.",
          "assistant": "The package still references [dated source]. Record your observation and affected tasks here. A qualified amendment and downstream correction are needed.",
          "controls": [
            "Review package",
            "Flag changed equipment",
            "Request clarification/materials",
            "Record qualified amendment",
            "Return to lead"
          ]
        },
        "4": {
          "title": "Visit state and access exception",
          "intent": "Display actual attendance, appointment version, applicable access and any changed conditions. Offer concise status changes without requiring constant interaction during work. A no-access event is not performed service, a missed visit is not a verified technical result, and leaving the site does not close purchased obligations.",
          "speaker": "Technician",
          "asks": "There is no access.",
          "assistant": "Record the access exception. BOB owns the next arrangement; the care item remains open.",
          "controls": [
            "Record attendance",
            "Access unavailable",
            "Pause work",
            "Contact lead",
            "View supported urgent route"
          ]
        },
        "5": {
          "title": "Actual work and evidence capture",
          "intent": "Per-item controls keep original maintenance, BOB-funded correction and additional approved work distinct. Show applicable module/criteria and fields for actual work, observation/evidence, limitations, material/time use and partial/blocked reasons. Evidence requirements are qualified module decisions, not a universal photo mandate. No default completed checks or timer-generated work proof.",
          "speaker": "Technician note",
          "asks": "Could not complete [item]; [observed reason].",
          "assistant": "[Item] remains incomplete, with [stated limitation].",
          "controls": [
            "Record performed work",
            "Record limitation",
            "Leave item incomplete",
            "Capture permitted note/evidence",
            "Raise qualified concern",
            "Save draft"
          ]
        },
        "6": {
          "title": "Qualified result review",
          "intent": "Show a reviewable draft next to its sources and per-item evidence. Distinguish performed, verified, partial, blocked and disputed. Review findings/limitations, equipment corrections and appropriate household wording. Confirmation records actual actor/version/item scope; material edits invalidate affected prior confirmations and trigger appropriate downstream amendments.",
          "speaker": "Technician",
          "asks": "Remove ‘all work completed’; one item is blocked.",
          "assistant": "The draft now preserves [blocked item] and its stated limitation. Review the remaining result before confirming.",
          "controls": [
            "Confirm scoped result",
            "Edit/reject draft",
            "Mark disputed",
            "Request qualified review",
            "Return to evidence"
          ]
        },
        "7": {
          "title": "Exception and accepted handoff",
          "intent": "Present original account, work/plan/evidence links, unresolved item, urgency source/uncertainty and category. Maintenance omission goes to F2/F4; a separately chargeable finding goes to F3 with qualified evidence and choices. Show proposed/requested/accepted recipient, next action and supported update separately.",
          "speaker": "Lead",
          "asks": "The technician sent the concern.",
          "assistant": "It is received, but no recipient has accepted the next action. [Existing owner] still carries it.",
          "controls": [
            "Request follow-through",
            "Accept ownership",
            "Escalate unaccepted handoff",
            "Open F3 decision",
            "Open F4 case"
          ]
        },
        "8": {
          "title": "Household result, purchased-care ledger and reconciliation",
          "intent": "Show qualified result, affected household/equipment/package/dispatch/purchased-care destinations and actual update states. Keep confirmed visit work beside remaining due/blocked/disputed care, current owner/action and supported update. Administrative closure is labeled for that episode only. Failed publication does not erase the actual work; it remains a distinct owned failure.",
          "speaker": "Lead",
          "asks": "The visit is finished. Is the purchased-care record done?",
          "assistant": "The episode has [confirmed result]. [Remaining obligation] is still open with [accepted owner/action]. [Destination] has not yet confirmed the update.",
          "controls": [
            "Publish permitted result",
            "Inspect update proof",
            "Resolve conflict",
            "View remaining care",
            "Open recovery",
            "Use supported outage record"
          ]
        }
      }
    },
    "9": {
      "name": null,
      "source": "docs/product/ninth-flow-design-brief.md",
      "views": {
        "1": {
          "title": "Commitment register and coverage",
          "intent": "Desktop shows a readable list of household commitments, term/scope version, due or unresolved care, current owner/action, source freshness and coverage gaps. Mobile defaults to a concise action/commitment list with the same facts and direct detail. Keep filtered scope visible; distinguish unknown due care from none due. Include former households with continuing cases/obligations where actual F7 rules require them.",
          "speaker": "Lead",
          "asks": "Who still needs care?",
          "assistant": "Within [permitted cohort/version], [sourced items] need action. [Inventory discrepancy] is unresolved, so this cannot establish that every household is accounted for.",
          "controls": [
            "Inspect commitments",
            "Search/filter",
            "Show omitted/unknown records",
            "Reconcile inventory",
            "Open household"
          ]
        },
        "2": {
          "title": "Household purchased-care detail",
          "intent": "Show the actual agreed unit/task scope and independent membership/order/payment/activation, appointment/access and qualified package states. Keep performed/verified results beside remaining/partial/disputed items and open F4 cases, original report time and actual accepted owner. A reported equipment-count heuristic cannot silently narrow the accepted scoped purchase or invent a broader entitlement.",
          "speaker": "Lead",
          "asks": "The visit was closed.",
          "assistant": "The visit record is closed with [qualified scoped result]. [Remaining item] still has [state/owner/action]. Purchased care is not complete.",
          "controls": [
            "Inspect evidence",
            "View current package",
            "Open remaining item",
            "Check appointment/access",
            "Open F4/F6",
            "View actual departure consequences"
          ]
        },
        "3": {
          "title": "Qualified workload, capacity and funding",
          "intent": "Display candidate/qualified workload separately from observed work. Include preparation, travel, materials, review, follow-up and backup effort; show technician qualification, actual acceptance and unavailable constraints. Financial detail is restricted to authorized actors and separates sourced actual amounts, estimated costs, remaining commitments and unverified funding. Do not turn membership prepayment or a forecast margin into spendable surplus.",
          "speaker": "Lead",
          "asks": "Can the backup cover this?",
          "assistant": "Backup is [requested/unaccepted state]. The plan is not staffed on that basis. [Qualified workload or funding gap] also remains.",
          "controls": [
            "Inspect workload sources",
            "Request qualified review",
            "Inspect staff acceptance",
            "Check material state",
            "Request financial review",
            "Expose resource gap"
          ]
        },
        "4": {
          "title": "Plan options and commitment impact",
          "intent": "Compare options against the same current scope, qualified constraints, access, staff/material acceptance and financial inputs. Show changed versus unchanged items, forecast limitations, affected existing obligations and unresolved acceptance. Candidate enrollment appears as a proposed additional obligation; existing care is retained in every option. Include applied enrollment restriction separately from a decision recommendation.",
          "speaker": "Lead",
          "asks": "Add another household if it funds the backlog.",
          "assistant": "Expected enrollment does not fund the existing shortfall. Review actual remaining costs, accepted capacity and financial support. Existing obligations stay owned.",
          "controls": [
            "Compare options",
            "Edit assumptions",
            "Request accepted assignment",
            "Record authorized plan decision",
            "Request/record admission review",
            "Apply permitted enrollment limit",
            "Request funded continuity"
          ]
        },
        "5": {
          "title": "Sourced risks and next actions",
          "intent": "List missing modules/materials, stale plans, staffing gaps, overdue items and missed supported updates with source/time, uncertainty and current owner. A qualified urgency assessment is distinguishable from an operational flag. Economic attractiveness, social activity or model confidence cannot quietly set service priority.",
          "speaker": "Lead",
          "asks": "Move the expensive household to the bottom.",
          "assistant": "That would weaken [accepted care/qualified timing]. The operating plan needs review within the agreed promise; projected cost is not authority to downgrade care.",
          "controls": [
            "Inspect reason",
            "Request qualified urgency review",
            "Accept next action",
            "Open original case",
            "Escalate unsupported commitment"
          ]
        },
        "6": {
          "title": "Owned intervention and accepted handoff",
          "intent": "Show original issue/account, category, source, exact next action, requested and accepted recipient, supported update and resource dependencies. Keep original maintenance, BOB-funded correction and authorized additional work separate. A recipient without qualification, authority or real capacity cannot be shown as accepted coverage.",
          "speaker": "Lead",
          "asks": "I sent it to the replacement.",
          "assistant": "The request exists; [acceptance] is still pending. [Current owner] retains the next action.",
          "controls": [
            "Request qualified help/backup",
            "Accept ownership",
            "Request material/financial action",
            "Escalate unaccepted transfer",
            "Open F2/F3/F4"
          ]
        },
        "7": {
          "title": "Necessary household update",
          "intent": "Show the permitted household-specific change, qualified uncertainty/limitations, actual appointment or care state, next action/owner and any necessary choice. Keep draft/approved/queued/published/delivered/failed/unknown states separate. No other household’s price, staffing issue, account or complaint appears in the message. Do not imply safety monitoring or guaranteed emergency response.",
          "speaker": "Lead",
          "asks": "Tell them it’s handled.",
          "assistant": "The supported facts are [confirmed change] and [remaining action]. [Staff acceptance/work] is unresolved, so the update must show that limitation.",
          "controls": [
            "Review/edit update",
            "Publish within authority",
            "Inspect receipt",
            "Open necessary household choice",
            "Contact through supported person route"
          ]
        },
        "8": {
          "title": "Verified follow-through and continuing care",
          "intent": "Show each qualified result, actual applied record versions, unresolved household publication, purchased items and accepted next actions. Review after interruptions/input changes and at the actual term/renewal/exit boundary. Keep “plan reviewed,” “work verified,” “household informed” and “remaining purchased-care responsibility” distinct. An administratively closed planning period cannot turn remaining items into completed care.",
          "speaker": "Lead",
          "asks": "Everything is green; may I close the period?",
          "assistant": "That status covers [declared records/version]. [Missing/partial/disputed item] and [destination gap] remain. Period closure cannot discharge those obligations.",
          "controls": [
            "Inspect F8 evidence",
            "Verify affected records",
            "Resolve conflict",
            "Reopen affected action",
            "View remaining care",
            "Verify enrollment limit",
            "Open recovery"
          ]
        }
      }
    }
  },
  "research_tasks": [
    "Explain membership versus purchased work and complete joining cost.",
    "Report accessible equipment information; skip unsafe photos.",
    "Locate current scope and terms; identify unresolved policies.",
    "Authorize only a specific current purchase; test ambiguous yes.",
    "Distinguish confirmed/failed/unknown payment and activation.",
    "Request a member-chosen date without inventing capacity.",
    "Understand qualified findings and decline additional spending.",
    "Obtain accepted human recovery and inspect actual remedy outcome.",
    "Inspect protected earned commitments without compulsory recruiting.",
    "Correct/export information and distinguish pending from enforced opt-out.",
    "Continue or leave membership while preserving purchased-care obligations.",
    "Rehearse technician evidence, qualified review and scoped completion.",
    "Rehearse oversight using qualified workload, accepted capacity and actual funding."
  ],
  "unresolved": [
    {
      "decision": "Exact membership benefits and limits",
      "needed": "Funded routine-help scope, human availability, records/reminders treatment and comprehension test."
    },
    {
      "decision": "Unit definition and covered visit work",
      "needed": "Qualified equipment-specific checklist, unit/count exceptions, materials and exclusions; a complete agreed quote."
    },
    {
      "decision": "Geography and appointment delivery",
      "needed": "Address eligibility, actual reserved qualified capacity, booking/rescheduling terms and contingency coverage."
    },
    {
      "decision": "Complete charge and money timing",
      "needed": "Tax/fees/materials policy, collection date, payment execution, provider settlement and invoicing."
    },
    {
      "decision": "Membership term and member-price applicability",
      "needed": "Activation/effective dates, eligibility for future bookings, quote validity and transition of accepted commitments."
    },
    {
      "decision": "Cancellation, refunds and renewal",
      "needed": "Separate commercial-unit policies, consent and billing controls, owed remedy handling, funded verified exit."
    },
    {
      "decision": "Supplier deals and shared improvements",
      "needed": "Actual negotiated scopes/orders, quality and capacity, relevant benefit mechanisms and their funded economics."
    },
    {
      "decision": "Privacy and household roles",
      "needed": "Signup purposes, member-visible information, household purchase roles, downstream enforcement, retention/export/deletion arrangements."
    }
  ],
  "fixture_ids": {
    "quote": "Q-1042",
    "membership": "M-1042",
    "visit": "V-1042",
    "receipt": "R-77310",
    "home": "Cary, NC",
    "reported_units": 2
  }
}
